<section id="editUser">
  <div class="row justify-content-center my-3">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="user-details-form-container">
        <mat-card class="shadow p-0">
          <form [formGroup]="editConsumerForm" (ngSubmit)="editConsumerSubmit($event)">
            <div class="form-inner content-details-blk">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="row g-0">
                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center">
                      <h4 class="form-item-label" translate>
                        pages.newRetailer.firstName
                      </h4>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
                      <div class="form-item-input">
                        <mat-form-field appearance="outline" class="w-100">
                          <input matInput required [textMask]="{ mask: charMask, guide: false }"
                            formControlName="firstName" readonly placeholder="{{
                              'pages.placeholders.Enterfirstname' | translate
                            }}" />
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="row g-0">
                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center">
                      <h4 class="form-item-label" translate>
                        pages.newRetailer.lastName
                      </h4>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
                      <div class="form-item-input">
                        <mat-form-field appearance="outline" class="w-100">
                          <input matInput  [textMask]="{ mask: charMask, guide: false }"
                            formControlName="lastName" readonly placeholder="{{
                              'pages.placeholders.Enterlastname' | translate
                            }}" />
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="row g-0">
                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center">
                      <h4 class="form-item-label" translate>
                        pages.newRetailer.emailInput

                      </h4>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
                      <div class="form-item-input">
                        <mat-form-field appearance="outline" class="w-100">
                          <input matInput required readonly placeholder="{{
                              'pages.AddProviders.EnteremailAddress' | translate
                            }}" formControlName="emailId" />
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="row g-0">
                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center">
                      <h4 class="form-item-label" translate>
                        pages.newRetailer.mobileNumber

                      </h4>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
                      <div class="form-item-input">
                        <mat-form-field appearance="outline" class="w-100">
                          <input matInput [textMask]="{ mask: phone }" required readonly formControlName="mobileNumber"
                            placeholder="{{
                              'pages.Creditlinebalance.Entermobilenumber'
                                | translate
                            }}" />
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="row g-0">
                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center">
                      <h4 class="form-item-label" translate>
                        pages.newRetailer.status

                      </h4>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
                      <div class="form-item-input">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-select matInput required formControlName="userStatus">
                            <mat-option value="Active">Active</mat-option>
                            <mat-option value="InActive">InActive</mat-option>
                            <mat-option [disabled]="true" value="Hold">Hold</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="row g-0">
                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center">
                      <h4 class="form-item-label" translate>
                        Total Loyalty Points
                        <span class="required">*</span>
                      </h4>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
                      <div class="form-item-input">
                        <mat-form-field appearance="outline" class="w-100">
                          <input matInput required type="text" maxlength="5"
                            formControlName="totalLoyaltyPoints" placeholder="Enter Total Loyalty Points"  [(ngModel)]="loyaltyPt" (keyup)="onChangeLoyaltyPt($event)"/>
                           </mat-form-field>
                           <div *ngIf="showErrorMsg && errMsg.length>0"><p class="text-danger">{{errMsg}}</p></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">

                <div class="col-lg-6 col-md-6 col-xs-12 notification-switch">
                  <div class="row g-0">
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 align-self-center  toggle-width">
                      <div class="form-item-toggle">
                        <mat-slide-toggle (change)="onToggleChanges()" color="primary" class="mb-2" formControlName="enrollPromotionalText">
                        </mat-slide-toggle>
                      </div>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center">
                      <h4 class="form-item-label" translate>
                        pages.ManageConsumer.REWARDS_TEXTS
                      </h4>
                    </div>
                  </div>
                  <!-- <div class="row g-0">
                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center">
                      <h4 class="form-item-label" translate>
                        Receive Promotional Texts
                      </h4>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
                      <div class="form-item-toggle">
                        <mat-slide-toggle color="primary" class="mb-2" formControlName="enrollPromotionalText">
                        </mat-slide-toggle>
                      </div>
                    </div>
                  </div> -->
                  <div class="row g-0">
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 align-self-center toggle-width">
                      <div class="form-item-toggle">
                        <mat-slide-toggle (change)="onToggleChanges()" color="primary" class="mb-2" formControlName="enrollPromotionalEmail">
                        </mat-slide-toggle>
                      </div>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center">
                      <h4 class="form-item-label" translate>
                        pages.ManageConsumer.PROMO_EMAILS
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-footer mt-0 mb-4">
              <ul class="list-inline text-center">
                <li class="list-inline-item">
                  <button mat-raised-button [disabled]="checkSubmitDisplayed()" color="primary" type="submit">
                    <span translate class="translate">pages.newRetailer.update</span>
                  </button>
                </li>
                <li class="list-inline-item">
                  <button mat-stroked-button color="primary" type="button" (click)="onCancel()">
                    <span translate class="translate">pages.newRetailer.cancel</span>
                  </button>
                </li>
                <li class="list-inline-item"></li>
              </ul>
            </div>
          </form>
        </mat-card>
      </div>
    </div>
  </div>
</section>